import React from 'react';

import {createRoot} from 'react-dom/client';
import * as Cesium from 'cesium';

import App from '@components/App';
import {config} from '@components/Constants';

if (!config.CESIUM_ACCESS_TOKEN) {
  throw new Error('no access token for cesium');
}
Cesium.Ion.defaultAccessToken = config.CESIUM_ACCESS_TOKEN;

const container = document.querySelector('#root');
if (!container) {
  throw new Error('unable to find a container');
}
const root = createRoot(container);
root.render(<App />);
